import { AffiliateKitPages, Application, Pages } from '@monorepo/types';

export enum PagePath {
  Root = '/',
  Login = '/login',
  Register = '/register',
  RegisterContest = '/register?contest-registration=true',
  Overview = '/overview',
  Orders = '/orders',
  Contests = '/contests',
  ContestCategory = '/contests-category',
  Profile = '/profile',
  Affiliation = '/affiliate',
  AffiliateProgram = '/affiliate-program',
  Achievements = '/achievements',
  Playbook = '/playbook',
  Partners = '/partners',
  NewAccount = '/new-account',
  NewAddon = '/new-addon',
  Autochartist = '/autochartist',
  AssetsSpecifications = '/assets-specifications',
  HubDownloads = '/hub-downloads',
  HubVod = '/hub-vod',
  TradingPlan = '/trading-plan',
  AffiliateKit = '/affiliate-kit',
  PerformanceCoach = '/performance-coach',
  AssetsManagement = '/assets-management',
  TradeTalk = '/trade-talk',
  CommunityStats = '/asset-stats',

  Position = '/position',
  Charts = '/charts',
  Purchase = '/purchase',
  AfterPurchase = '/after-purchase',
  Dashboard = '/dashboard',
  Welcome = '/welcome',
  ContestOverview = '/contest-overview',
  EditProfile = '/edit',
  Verification = '/verification',
  ThankYou = '/thank-you',
  Blacklisted = '/blacklisted',
  Coupons = '/purchases/coupons',
  PrivacyOptOut = '/privacy-opt-out',
}

export enum SubPages {
  Article = 'article',

  TradeTalkFeeds = 'feed',
  AllTradeTalks = 'all-talks',
  PicksTradeTalks = 'picks',
  MyTradeTalks = 'my-talks',
}

const baseUrl = 'https://lp.tradethepool.com';
const the5ersBaseUrl = 'https://lp.the5ers.com';

export const StaticPagesUrls = {
  [Pages.Autochartist]: {
    [Application.TTP]: '',
    [Application.THE5ERS]: `${baseUrl}/the5ers-hub-autochartist/`,
  },
  [Pages.AssetsSpecifications]: {
    [Application.TTP]: '',
    [Application.THE5ERS]: `${baseUrl}/the5ers-hub-trading-assets/`,
  },
  [Pages.HubDownloads]: {
    [Application.TTP]: '',
    [Application.THE5ERS]: `${baseUrl}/the5ers-hub-downloads/`,
  },
  [Pages.HubVod]: {
    [Application.TTP]: '',
    [Application.THE5ERS]: `${baseUrl}/the5ers-hub-vod/`,
  },
  [Pages.TradingPlan]: {
    [Application.TTP]: '',
    [Application.THE5ERS]: `${baseUrl}/the5ers-hub-trading-plan/`,
  },
  [Pages.AffiliateKit]: {
    [Application.TTP]: `${baseUrl}/trade-the-pool-affiliate-kit/`,
    [Application.THE5ERS]: `${the5ersBaseUrl}/hub-affiliate-kit/`,
  },
  [Pages.PerformanceCoach]: {
    [Application.TTP]: '',
    [Application.THE5ERS]: 'https://the5ers.com/performance-coach/?hub=1',
  },
};

export const StaticAffiliateKitUrls = {
  [AffiliateKitPages.AffiliateKit]: {
    [Application.TTP]: `${baseUrl}/trade-the-pool-affiliate-kit/`,
    [Application.THE5ERS]: `${the5ersBaseUrl}/hub-affiliate-kit/`,
  },
  [AffiliateKitPages.AffiliateKitDark]: {
    [Application.TTP]: `${baseUrl}/trade-the-pool-affiliate-kit/`,
    [Application.THE5ERS]: `${the5ersBaseUrl}/hub-affiliate-kit-dark/`,
  },
};

export const FORBIDDEN_PRACTICES_LINKS: Record<Application, string> = {
  [Application.TTP]: 'https://tradethepool.com/the-program/#faqs',
  [Application.THE5ERS]:
    'https://help.the5ers.com/prohibited-trading-practices/',
};
